import { QuotationDO } from './';

export class QuotationContainerDO {

    public quoteContainerNum: String = null;
    public baseProductFamilyCd: String = null;
    public statusCd: String = null;
    public baseAgentCd: String = null;
    public quotationList: QuotationDO[] = [];

    public get $quoteContainerNum(): String {
        return this.quoteContainerNum;
    }

    public set $quoteContainerNum(value: String) {
        this.quoteContainerNum = value;
    }


    public get $baseProductFamilyCd(): String {
        return this.baseProductFamilyCd;
    }

    public set $baseProductFamilyCd(value: String) {
        this.baseProductFamilyCd = value;
    }


    public get $statusCd(): String {
        return this.statusCd;
    }

    public set $statusCd(value: String) {
        this.statusCd = value;
    }


    public get $baseAgentCd(): String {
        return this.baseAgentCd;
    }

    public set $baseAgentCd(value: String) {
        this.baseAgentCd = value;
    }


    public getQuotationList() {
        return this.quotationList;
    }
    public setQuotationList(quotationList: QuotationDO[]) {
        this.quotationList = quotationList;
    }

    // public id: Number = null;

    // public agentId: String = null;

    // public baseAgentCd: String = null;

    // public leadID: String = null;

    // public quotationContainerID: String = null;

    // public quotationContainerRefNum: String = null;

    // public quotationType: String = null;

    // public status: String = null;

    // public coverType: String = null;

    // public selectedPlan: String = null;

    // public fullName: String = null;

    // public registrationNum: String = null;

    // public registrationDt: String = null;

    // public registrationYear: String = null;

    // public seatingCapacity: String = null;

    // public sumInsured: String = null;

    // public quotationRefNum: String = null;

    // public vehicleTypeCd: String = null;

    // public vehicleMakeCd: String = null;

    // public vehicleModelCd: String = null;

    // public vehicleVariant: String = null;

    // public zoneCd: String = null;

    // public selectionZoneMethod: String = null;

    // public lastSyncDt: String = null;

    // public lastUploadDt: String = null;

    // public lastDownloadDt: String = null;

    // public state: String = null;

    // public defaultSumInsured: DoubleRange = null;

    // public basePlanRate: Number = null;

    // public quotationDt: Date = null;

    // public quotationList: QuotationDO[];


    // public get $id(): Number {
    //     return this.id;
    // }

    // public set $id(value: Number) {
    //     this.id = value;
    // }

    // public get $agentId(): String {
    //     return this.agentId;
    // }

    // public set $agentId(value: String) {
    //     this.agentId = value;
    // }

    // public get $baseAgentCd(): String {
    //     return this.baseAgentCd;
    // }

    // public set $baseAgentCd(value: String) {
    //     this.baseAgentCd = value;
    // }

    // public get $leadID(): String {
    //     return this.leadID;
    // }

    // public set $leadID(value: String) {
    //     this.leadID = value;
    // }

    // public get $quotationContainerID(): String {
    //     return this.quotationContainerID;
    // }

    // public set $quotationContainerID(value: String) {
    //     this.quotationContainerID = value;
    // }

    // public get $quotationContainerRefNum(): String {
    //     return this.quotationContainerRefNum;
    // }

    // public set $quotationContainerRefNum(value: String) {
    //     this.quotationContainerRefNum = value;
    // }

    // public get $quotationType(): String {
    //     return this.quotationType;
    // }

    // public set $quotationType(value: String) {
    //     this.quotationType = value;
    // }

    // public get $status(): String {
    //     return this.status;
    // }

    // public set $status(value: String) {
    //     this.status = value;
    // }

    // public get $coverType(): String {
    //     return this.coverType;
    // }

    // public set $coverType(value: String) {
    //     this.coverType = value;
    // }

    // public get $selectedPlan(): String {
    //     return this.selectedPlan;
    // }

    // public set $selectedPlan(value: String) {
    //     this.selectedPlan = value;
    // }

    // public get $fullName(): String {
    //     return this.fullName;
    // }

    // public set $fullName(value: String) {
    //     this.fullName = value;
    // }

    // public get $registrationNum(): String {
    //     return this.registrationNum;
    // }

    // public set $registrationNum(value: String) {
    //     this.registrationNum = value;
    // }

    // public get $registrationDt(): String {
    //     return this.registrationDt;
    // }

    // public set $registrationDt(value: String) {
    //     this.registrationDt = value;
    // }

    // public get $registrationYear(): String {
    //     return this.registrationYear;
    // }

    // public set $registrationYear(value: String) {
    //     this.registrationYear = value;
    // }

    // public get $seatingCapacity(): String {
    //     return this.seatingCapacity;
    // }

    // public set $seatingCapacity(value: String) {
    //     this.seatingCapacity = value;
    // }

    // public get $sumInsured(): String {
    //     return this.sumInsured;
    // }

    // public set $sumInsured(value: String) {
    //     this.sumInsured = value;
    // }

    // public get $quotationRefNum(): String {
    //     return this.quotationRefNum;
    // }

    // public set $quotationRefNum(value: String) {
    //     this.quotationRefNum = value;
    // }

    // public get $vehicleTypeCd(): String {
    //     return this.vehicleTypeCd;
    // }

    // public set $vehicleTypeCd(value: String) {
    //     this.vehicleTypeCd = value;
    // }

    // public get $vehicleMakeCd(): String {
    //     return this.vehicleMakeCd;
    // }

    // public set $vehicleMakeCd(value: String) {
    //     this.vehicleMakeCd = value;
    // }

    // public get $vehicleModelCd(): String {
    //     return this.vehicleModelCd;
    // }

    // public set $vehicleModelCd(value: String) {
    //     this.vehicleModelCd = value;
    // }

    // public get $vehicleVariant(): String {
    //     return this.vehicleVariant;
    // }

    // public set $vehicleVariant(value: String) {
    //     this.vehicleVariant = value;
    // }

    // public get $zoneCd(): String {
    //     return this.zoneCd;
    // }

    // public set $zoneCd(value: String) {
    //     this.zoneCd = value;
    // }

    // public get $selectionZoneMethod(): String {
    //     return this.selectionZoneMethod;
    // }

    // public set $selectionZoneMethod(value: String) {
    //     this.selectionZoneMethod = value;
    // }

    // public get $lastSyncDt(): String {
    //     return this.lastSyncDt;
    // }

    // public set $lastSyncDt(value: String) {
    //     this.lastSyncDt = value;
    // }

    // public get $lastUploadDt(): String {
    //     return this.lastUploadDt;
    // }

    // public set $lastUploadDt(value: String) {
    //     this.lastUploadDt = value;
    // }

    // public get $lastDownloadDt(): String {
    //     return this.lastDownloadDt;
    // }

    // public set $lastDownloadDt(value: String) {
    //     this.lastDownloadDt = value;
    // }

    // public get $state(): String {
    //     return this.state;
    // }

    // public set $state(value: String) {
    //     this.state = value;
    // }

    // public get $basePlanRate(): Number {
    //     return this.basePlanRate;
    // }

    // public set $basePlanRate(value: Number) {
    //     this.basePlanRate = value;
    // }

    // public get $quotationDt(): Date {
    //     return this.quotationDt;
    // }

    // public set $quotationDt(value: Date) {
    //     this.quotationDt = value;
    // }

    // public getQuotationList() {
    //     return this.quotationList;
    // }
    // public setQuotationList(quotationList: QuotationDO[]) {
    //     this.quotationList = quotationList;
    // }

}
